import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error - this is a benign error from Radix UI components
// that doesn't affect functionality but triggers React's error overlay
if (typeof window !== 'undefined') {
  // Override the error handler before React mounts
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress from window.onerror
  const resizeObserverErr = window.onerror;
  window.onerror = (message, ...args) => {
    if (typeof message === 'string' && message.includes('ResizeObserver')) {
      return true;
    }
    if (resizeObserverErr) {
      return resizeObserverErr(message, ...args);
    }
    return false;
  };

  // Suppress from error events
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true);

  // Suppress from unhandledrejection
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
      e.preventDefault();
      return true;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
